import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  selector: 'app-configuracion-tipo-visita-registrar',
  templateUrl: './configuracion-tipo-visita-registrar.component.html',
  styleUrls: ['./configuracion-tipo-visita-registrar.component.css'],
})
export class ConfiguracionTipoVisitaRegistrarComponent implements OnInit {
  model: ITipoVisitaModel = new TipoVisitaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  
  constructor(
    private router: Router,
    private tipoVisitaService: TipoVisitaService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) {}

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_TIPO_VISITA).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.tipoVisitaService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open('El tipo de visita fue registrado');
            this.router.navigate(['/configuracion', 'tipo-visitas']);
          });
        }
      });
    }
  }
}
